import { api } from "./api";

const  uploadFile = async(file: File) =>{
    try{
        const form_data = new FormData();
        form_data.append('file', file);
        form_data.append('extra', JSON.stringify({
            session:'realization_files'
        }))

        const {data} = await api.post('upload/file', form_data)
        return data.status === 'OK' ? data.uploads[0] : data;
    }catch(error:any){
        throw error
    }
}

export {
    uploadFile
}